import { schema } from 'normalizr';

const activeAlarm = new schema.Entity('activeAlarms', {}, { idAttribute: 'id' });
const activeAlarmsSchema = [activeAlarm];

export default activeAlarmsSchema;



// WEBPACK FOOTER //
// ./src/normalizr-schemas/activeAlarmsSchema.js